/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Shop_Repair_InvoiceInputs */

const en_case_doc_shop_repair_invoice = /** @type {(inputs: Case_Doc_Shop_Repair_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repair invoice`)
};

const pt_br2_case_doc_shop_repair_invoice = /** @type {(inputs: Case_Doc_Shop_Repair_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NF do reparo`)
};

/**
* | output |
* | --- |
* | "Repair invoice" |
*
* @param {Case_Doc_Shop_Repair_InvoiceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_shop_repair_invoice = /** @type {((inputs?: Case_Doc_Shop_Repair_InvoiceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Shop_Repair_InvoiceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_shop_repair_invoice(inputs)
	return pt_br2_case_doc_shop_repair_invoice(inputs)
});